// extracted by mini-css-extract-plugin
export var navBarNFT = "NavBar-module--navBarNFT--GXFz4";
export var navbar = "NavBar-module--navbar--w4Abo";
export var navbarList = "NavBar-module--navbarList--suVXl";